var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 18,
    viewBox: "0 0 32 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8773 9.00015C17.8773 13.9706 13.8753 18 8.93881 18C4.00233 18 0 13.9706 0 9.00015C0 4.02966 4.00203 0 8.93881 0C13.8756 0 17.8773 4.02966 17.8773 9.00015Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.679 9.00176C27.679 13.6804 25.678 17.4747 23.2096 17.4747C20.7412 17.4747 18.7402 13.6804 18.7402 9.00176C18.7402 4.32311 20.7409 0.528809 23.2093 0.528809C25.6777 0.528809 27.6787 4.32189 27.6787 9.00176",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6933 8.99814C31.6933 13.1891 30.9896 16.5886 30.1214 16.5886C29.2532 16.5886 28.5498 13.19 28.5498 8.99814C28.5498 4.80631 29.2535 1.40771 30.1214 1.40771C30.9893 1.40771 31.6933 4.806 31.6933 8.99814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMed);
export default __webpack_public_path__ + "static/media/med.052418668731918bf87821e84560f15d.svg";
export { ForwardRef as ReactComponent };